import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CampaignEditForm from './CampaignEditForm';
import CampaignList from './CampaignList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CampaignListView from './CampaignListView'


export default function CampaignDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.campaignDashboard);
  const [ campaignId, setCampaignId] = React.useState('');
  const [reloadCampaignList, setReloadCampaignList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CampaignEditForm 
            setReloadCampaignList={setReloadCampaignList}
            campaignId={campaignId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CampaignListView 
                      setCampaignId = {setCampaignId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
